import DatePicker, { ReactDatePickerProps, registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ptBR from "date-fns/locale/pt-BR";
import { twMerge } from "tailwind-merge";

interface IInputDateRHFV2Props extends ReactDatePickerProps {
  label?: string;
}

export const InputDateRHFV2 = ({
  label,
  className,
  ...props
}: IInputDateRHFV2Props) => {
  registerLocale("ptBR", ptBR);

  return (
    <div className="relative w-full [&_.react-datepicker-wrapper]:block [&_.react-datepicker-wrapper]:w-full">
      {label && (
        <label
          htmlFor={props.id}
          className="absolute -top-[9px] left-4 z-10 flex bg-gradient-to-t from-white from-50% to-transparent to-50% px-1 text-xs text-[#2d2d2d]"
        >
          {label}
        </label>
      )}

      <DatePicker
        {...props}
        dateFormat="dd/MM/yyyy"
        locale="ptBR"
        placeholderText="___/___/___"
        className={twMerge(
          "h-11 w-full rounded-lg border border-solid border-[#2d2d2d] bg-white pl-3.5 pr-10 font-['Mulish'] text-base font-normal text-[#2d2d2d] placeholder:text-[#9d9d9d] focus:outline-none",
          className,
        )}
      />

      <img
        src="/assets/svgs/icon-calendar-dark.svg"
        alt=""
        className="pointer-events-none absolute right-4 top-1/2 h-5 w-5 -translate-y-1/2"
      />
    </div>
  );
};
